import * as React from 'react';
import * as ReactDOM from 'react-dom';

import { AngularDirective } from '../../common/react/components/AngularDirective';
import { IOmniboxExternalScope } from '../../ts/controllers/OmniboxCtrl';
import { ReactDirectiveProps } from '../../ts/directives/reactDirectiveFactory';
import { KeydownOutsideDetector } from '../../ts/helpers/KeydownOutsideDetector';
import { Keys } from '../../ts/helpers/Keys';
import { MousedownOutsideDetector } from '../../ts/helpers/MousedownOutsideDetector';
import { vizHeaderSearchButtonImgTestId } from '../layout/PageHeaderSearch';
import { vizHeaderSearchOpenButtonTestId } from '../layout/VizViewerPageHeader';

export class HeaderSearchBox extends React.Component<HeaderSearchBox.Props, HeaderSearchBox.State> {

  static displayName = 'HeaderSearchBox';

  static element = React.createFactory(HeaderSearchBox);

  static minResultsWidth = 350;

  private static nextId = 1;

  private linkPadding = 15;

  private detachMousedownOutsideDetector: () => void;
  private detachKeyboardOutsideDetector: () => void;


  public render() {
    const resultsWidth = HeaderSearchBox.minResultsWidth > this.props.omniboxOpenWidth
      ? HeaderSearchBox.minResultsWidth
      : this.props.omniboxOpenWidth;

    const content = AngularDirective.element({
      angularContext: this.props.angularContext,
      setupScope: (scope: ng.IScope) => {
        const omniboxScope = <IOmniboxExternalScope>scope.$new();
        omniboxScope.closed = (event: BaseJQueryEventObject) => this.props.searchClosed(event);
        omniboxScope.closedWithoutNeedingFocus = (event: BaseJQueryEventObject) => this.props.searchClosedWithoutNeedingFocus(event);
        omniboxScope.isSearchOpen = this.props.isSearchOpen;
        return omniboxScope;
      },
      template: `<tb:omnibox width="${resultsWidth}" search-open="${this.props.isSearchOpen}" closed="closed(event)" closed-without-needing-focus="closedWithoutNeedingFocus(event)"></tb:omnibox>`
    });
    return React.createElement('div', {
      ref: 'omniboxSearchOpen',
      style: {
        marginLeft: this.linkPadding,
        width: this.props.omniboxOpenWidth+'px'
      }
    }, content);
  }

  public componentDidMount() {
    const searchClosedFn = (downEvent: JQueryEventObject) => {
      const targetElement = downEvent && $(downEvent.target);
      if (targetElement) {

        const isCloseIcon = targetElement.attr('data-tb-test-id') === vizHeaderSearchOpenButtonTestId
                            || targetElement.attr('data-tb-test-id') === vizHeaderSearchButtonImgTestId;

        if (isCloseIcon) {  // return focus to search button if closed using the X button
          this.props.searchClosed(downEvent);
        }
      }

      this.props.searchClosedWithoutNeedingFocus(downEvent);
    };

    // these catch the case when the search text box is open, without the omnibox open (no search term)
    // and a user clicks outside the search box or activates a menu outside the search box. In that case
    // we don't want the focus to return to the search buttons but we want to close the text boxm unless
    // the user clicked on the X (close) button.
    const id = '' + HeaderSearchBox.nextId++;
    this.detachMousedownOutsideDetector = MousedownOutsideDetector.attach(
      $(ReactDOM.findDOMNode(this)),
      (element: JQuery) => id,
      (downEvent: JQueryEventObject) => searchClosedFn(downEvent));

    this.detachKeyboardOutsideDetector = KeydownOutsideDetector.attach(
        $(ReactDOM.findDOMNode(this)),
        (element: JQuery) => id,
        (downEvent: JQueryEventObject) => searchClosedFn(downEvent),
        [Keys.Space, Keys.Enter, Keys.Escape]);
  }

  public componentWillUnmount() {
    this.detachMousedownOutsideDetector();
    this.detachKeyboardOutsideDetector();
  }

}

export module HeaderSearchBox {

  export interface Props extends ReactDirectiveProps {
    omniboxOpenWidth: number;
    searchClosed: (event: BaseJQueryEventObject) => void;
    searchClosedWithoutNeedingFocus: (event: BaseJQueryEventObject) => void;
    isSearchOpen: boolean;
  }

  export interface State {
  }

}
